export default __webpack_public_path__ + "static/media/fj.3711068b.svg";